export default __webpack_public_path__ + "static/media/Godaddy.f7a7a9fe.png";